export default {
  title: {
    label: 'Titel',
    required: true,
    section: 'general',
    // eslint-disable-next-line max-len
    info: 'Tragen Sie hier den Titel der museumspädagogischen Themenführung ein. Verwenden Sie dazu einen möglichst aussagekräftigen und griffigen Titel, der das Thema umschreibt.'
  },
  duration: {
    label: 'Dauer',
    required: true,
    type: 'number',
    section: 'general',
    // eslint-disable-next-line max-len
    info: 'Tragen Sie hier die Dauer der museumspädagogischen Themenführung in Minuten ein (mind. 10 Minuten). Es kann keine Zeitspanne eingetragen werden.'
  },
  maxParticipants: {
    label: 'Maximale Teilnehmer',
    required: true,
    type: 'number',
    section: 'general',
    // eslint-disable-next-line max-len
    info: 'Tragen Sie hier die maximale Anzahl der Teilnehmer ein. <br />Beachten Sie: In Bayern gilt pro Klasse die Obergrenze von 35 Schülern.'
  },
  meetingPoint: {
    label: 'Treffpunkt',
    required: true,
    section: 'general',
    // eslint-disable-next-line max-len
    info: 'Ist Ihr Treffpunkt mit der Schulklasse nicht der Haupteingang des Museums, können Sie hier konkrete Angaben zum Treffpunkt machen (z. B. Am Parkplatz vor dem Museum).'
  },
  description: {
    label: 'Beschreibung',
    required: true,
    type: 'number',
    section: 'general',
    // eslint-disable-next-line max-len
    info: 'Formulieren Sie hier einen kurzen Text, der Ihre Themenführung inhaltlich beschreibt. Gehen Sie nach der folgenden Struktur: <ul><li>kurze Erläuterung des Themas, </li><li>3-4 Leitobjekte mit Objektbezeichnung und Datierung, </li><li>Alleinstellungsmerkmal.</li></ul> Inkl. Leerzeichen sollte der Text zwischen 100 und max. 1000 Zeichen umfassen. Verwenden Sie aussagekräftige Schlagwörter, so dass der Eintrag auch für Nutzer, die über Suchmaschinen recherchieren, auf ndbar ist.'
  },
  expireAt: {
    label: 'Läuft aus am',
    required: true,
    type: 'date',
    section: 'general',
    // eslint-disable-next-line max-len
    info: 'Die Laufzeit der MUSbi-Veranstaltungen beträgt maximal 4 Jahre. Nach Ablauf der Frist können die Programme überprüft und neu eingestellt werden.'
  },

  schools: {
    label: 'Schule',
    section: 'reference',
    // eslint-disable-next-line max-len
    info: 'Wählen Sie hier die Schulart aus dem Dropdown-Menü aus, für die Ihre museumspädagogische Themenführung infrage kommt. <br />Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen.',
    note: '(Mehrfachauswahl möglich)'
  },
  curriculums: {
    label: 'Lehrplanbezug',
    section: 'reference',
    // eslint-disable-next-line max-len
    info: 'Geben Sie hier den Lehrplanbezug Ihres museumspädagogischen Programms an.<br /><br />Beachten Sie die Formatvorgabe:<br /><br /><i>Schulart Doppelpunkt Abkürzung des Fachs ohne Leerzeichen Jahrgangsstufe Leerzeichen Gliederungszahl des Lehrplanabschnitts</i> (z. B. Grundschule: HSU3/4 3.2). Fächer bitte durch Strichpunkt trennen. Die Lehrpläne können unter <a href="http://www.lehrplanplus.bayern.de/">www.lehrplanplus.bayern.de</a> eingesehen werden.'
  },
  grades: {
    label: 'Jahrgangsstufe',
    section: 'reference',
    // eslint-disable-next-line max-len
    info: 'Bitte geben Sie maximal fünf aufeinanderfolgende Jahrgangsstufen ein. Sollte sich die museumspädagogische Themenführung in ähnlicher Form auch für weitere Jahrgangsstufen eignen, geben Sie dies bitte als eigenständige museumspädagogische Themenführung ein. Sie können den Namen der museumspädagogischen Themenführung beibehalten, ergänzen Sie aber bitte z.B. „1.-4. Klasse“, „5.-8. Klasse“. <br />Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen.'
  },
  subjects: {
    label: 'Schulfächer',
    section: 'reference',
    // eslint-disable-next-line max-len
    info: 'Wählen Sie die Schulfächer aus, für die Ihre museumspädagogische Themenführung geeignet ist. <br />Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen.',
    note: '(Mehrfachauswahl möglich)'
  },
  languages: {
    label: 'Sprachen',
    section: 'reference',
    // eslint-disable-next-line max-len
    info: 'Bitte geben Sie an, in welchen Sprachen Ihre museumspädagogische Themenführung verfügbar ist. <br />Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen.',
    note: '(Mehrfachauswahl möglich)'
  },

  bookingStart: {
    label: 'buchbar von',
    required: true,
    type: 'date',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Bieten Sie Ihre Themenführung ganzjährig an, wäre hier der Januar einzutragen. Falls die Themenführung nur in bestimmten Monaten des Jahres gebucht werden kann, geben Sie hier bitte den frühest möglichen Zeitpunkt an.'
  },
  bookingEnd: {
    label: 'buchbar bis',
    required: true,
    type: 'number',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Bieten Sie Ihre Themenführung ganzjährig an, wäre hier der Dezember einzutragen. Falls die Themenführung nur in bestimmten Monaten des Jahres gebucht werden kann, geben Sie hier bitte den frühest möglichen Zeitpunkt an.'
  },
  bookableOutOfSeason: {
    label: 'ja, außerhalb der Museumssaison buchbar',
    type: 'checkbox',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: ''
  },
  bookableOutOfOpeningTimes: {
    label: 'ja, außerhalb der Museumsöffnungszeiten buchbar',
    type: 'checkbox',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Setzen Sie einen Haken, wenn Ihre museumspädagogische Themenführung unabhängig von den Museumsöffnungszeiten buchbar ist.'
  },
  days: {
    label: 'an folgenden Wochentagen',
    type: 'number',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Wählen Sie aus dem Dropdown-Menü aus, an welchen Wochentagen Ihre museumspädagogische Themenführung buchbar ist. <br />Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen.',
    note: '(Mehrfachauswahl möglich)'
  },
  temporarilyNotBookable: {
    label: 'Temporär nicht buchbar',
    type: 'checkbox',
    section: 'booking',
    // eslint-disable-next-line max-len

  },
  temporarilyNotBookableReason: {
    label: 'Grund',
    section: 'booking',
  },
  generalPrice: {
    required: true,
    type: 'number',
    label: 'Pauschalbetrag',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Bitte geben Sie hier den Betrag ein, den Ihre museumspädagogische Themenführung pauschal kostet. Bitte beachten Sie, dass Sie entweder einen Pauschalbetrag angeben können oder im nächsten Feld einen Preis pro Schüler in Kombination mit einem Mindestbetrag festlegen. Ein doppelter Eintrag ist nicht möglich.'
  },
  minPrice: {
    label: 'Mindestbetrag',
    required: true,
    type: 'number',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Bitte geben Sie hier den Mindestbetrag ein, der für Ihre museumspädagogische Themenführung bezahlt werden muss. Diese Angabe ist wichtig, da Schulklassen keine einheitlichen Schülerzahlen haben. Bitte beachten Sie auch, dass Sie auch einen Betrag pro Schüler angeben müssen.'
  },
  costsByPerson: {
    label: 'Preis pro Schüler',
    required: true,
    type: 'number',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Falls Sie sich für diese Variante entschieden haben, geben Sie hier bitte den Betrag ein, den jeder Schüler für die Teilnahme an Ihrem museumspädagogischen Programm zu entrichten hat. Bitte beachten Sie, auch einen Mindestbetrag anzugeben, da Schulklassen keine einheitlichen Schülerzahlen haben.'
  },
  specialConditionsForRemedialClasses: {
    label: 'Gesonderte Konditionen für Förderklassen',
    type: 'checkbox',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Setzen Sie den Haken, wenn für Förderklassen gesonderte Konditionen gelten.'
  },
  freeEntryForTeachersAtPrevisit: {
    label: 'Freier Eintritt für Lehrkräfte bei Vorbesuchen',
    type: 'checkbox',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Setzen Sie den Haken, wenn Lehrkräfte bei Vorbesuchen keinen Eintritt bezahlen müssen.'
  },

  links: {
    label: 'PDF-Dateien',
    section: 'media',
    // eslint-disable-next-line max-len
    info: 'Durch Anklicken der Schaltfäche „Dateien auswählen“ können Sie PDF-Dateien (z. B. Flyer) exklusiv zu dieser Themenführung hochladen. Es können mehrere Dateien hochgeladen werden. Bitte achten Sie auf die Dateigröße (max. 1 MB pro Datei) und eine websichere Benennung (keine Leeroder Sonderzeichen, keine Umlaute). <br />Bitte geben Sie zu jedem PDF stets eine aussagekräftige Beschreibung mit an, da diese der spätere Anzeigename für das PDF ist. <br />Für die Wahrung der Urheberund Persönlichkeitsrechte ist das jeweilige Museum verantwortlich.',
    note: '(Mehrfachauswahl möglich)'
  },
  media: {
    label: 'Bilder',
    section: 'media',
    // eslint-disable-next-line max-len
    info: 'Durch Anklicken der Schalt äche „Dateien auswählen“ können Sie Bilder (JPG, PNG) zu Ihrer museumspädagogischen Themenführung hochladen. Es können mehrere Bilder hochgeladen werden. Bitte achten Sie auf die Bildgröße (minimal 1024 x 768 Pixel) sowie die Dateigröße (max. 1 MB) und eine websichere Benennung (keine Leeroder Sonderzeichen, keine Umlaute). <br />Bitte geben Sie zu jedem Bild stets eine aussagekräftige Beschreibung mit an, die für den Nutzer später sichtbar ist. Über die Checkbox „als Bannerbild verwenden“ können Sie das Hauptbild bei mehreren Bildern auswählen. <br />Für die Wahrung der Urheberund Persönlichkeitsrechte ist das jeweilige Museum verantwortlich.',
    note: '(Mehrfachauswahl möglich)'
  },

  hostelUrl: {
    label: 'Jugendherberge',
    placeholder: 'http://url-der-jugendherberge.de',
  },
}



// WEBPACK FOOTER //
// ./src/guided-tour/fieldSpecs.js